import { makeRequest } from "src/api/request";

export const getMariaData = async () =>
  await makeRequest.get<AdminAPI.Maria.MariaResearch.Response>("/admin/maria/research/get_research_dashboard/");

export const analyzeMarket = async () =>
  await makeRequest.post<AdminAPI.Maria.MariaResearch.Response>("/admin/maria/research/analyze_market/", {
    timeout: 3600000,
  });

export const findOpportunities = async () =>
  await makeRequest.post<AdminAPI.Maria.MariaResearch.Response>("/admin/maria/research/find_opportunities/", {
    timeout: 3600000,
  });

export const testWeeklyDealsEmail = async (params: {
  max_properties_per_email?: number;
  days_back?: number;
  location_filter?: string;
  recipient_email?: string;
}) =>
  await makeRequest.post<AdminAPI.Scout.Research.WeeklyDealsEmail.Response>("/admin/scout/research/test_weekly_deals_email/", params, {
    timeout: 300000, // 5 minutes timeout
  });
